/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Br_History_Key_Salttankdefect2Inputs */



/**
* | output |
* | --- |
* | "Salt tank level defect" |
*
* @param {Br_History_Key_Salttankdefect2Inputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
const br_history_key_salttankdefect2 = /** @type {((inputs?: Br_History_Key_Salttankdefect2Inputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Br_History_Key_Salttankdefect2Inputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Salt tank level defect")
	return /** @type {LocalizedString} */ ("Défaut niveau bac à sel")
});
export { br_history_key_salttankdefect2 as "br_history_key_saltTankDefect" }